import { Component, OnInit } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';

@Component({
  selector: 'app-terms-and-conditions',
  templateUrl: './terms-and-conditions.page.html',
  styleUrls: ['./terms-and-conditions.page.scss'],
})
export class TermsAndConditionsPage implements OnInit {
  istermsAndCondition :boolean = true;
 
  constructor(private modalCtrl: ModalController,navParams: NavParams) { 
    this.istermsAndCondition = navParams.get('isTermsAndConditions');

  }

  ngOnInit() {
  }

  confirm(){
    return this.modalCtrl.dismiss();

  }

}
